import { title } from "process";
import { ProjectProps } from "../src/components/work/projectDetails";

export const loaderText = {
  text: "Vítejte na mém portfoliu.",
};

export const heroText = {
  text: "Vítejte na mém portfoliu.",
};

export const aboutText = {
  title: "O MNĚ",
  text1:
    //"pursuing my B.tech in woxen university. I want to learn more about Front-end & Full Stack Development and i have a good command in javascript, Next.js, react.js, HTML&CSS. I believe in trying out new things and picking up challenges as it is always great to have knowledge in variety of subjects and have various experiences to share. im more interested in developing my weaknesses...",
    "Jsem studentem vysoké školy se zájmem o programování na frontendu i backendu. Mám zkušenosti s jazyky jako Python, C a GO, ale nejlépe ovládám C# a TypeScript. Rád se učím nové technologie a jsem otevřený novým výzvám. Mým cílem je stát se Full Stack Developerem a vytvářet inovativní a užitečné aplikace.",
  text2:
    //"Whether I’m designing a sleek user interface or coding a complex application, I’m always striving to create something unique and innovative. I love experimenting with new technologies and staying up-to-date with the latest trends in the tech world.",
    "Ať už navrhuji elegantní uživatelská rozhraní, nebo programuji komplexní aplikace, vždy se snažím vytvořit něco jedinečného a inovativního. Experimentuji s novými technologiemi a sleduji nejnovější trendy ve světě technologií.",
  text3:
    //"Right now, I’m working on some exciting projects that I can’t wait to share with you. But I’m always open to new opportunities and collaborations.",
    "V současné době se zaměřuji na zdokonalování v tvorbě webových stránek s Next.js a usiluji o rozšíření svých dovedností v oblasti moderního webového vývoje.",
};

export const workText = {
  h1: "Vybrané projekty",
  h2: "Podívejte se na některé z mých prací!",
  more: "Více",
  //projects: [{}],
};

export const contactText = {
  mail: {
    title: "KONTAKT",
    text1: "Máte otázku, návrh, projekt nebo chcete spolupracovat na něčem?",
    text2: "Napište mi e-mail",
    mail: "edem.dev@gmail.com", //TODO: fix (for now keep broken, avoid spam)
    subject: "",
    //"?subject=Lets%20work%20together!&amp;body=Hello%2C%20I%20think%20we%20need%20you%20to%20work%20on%2Fcollaborate%20this%20particular%20product...%20Reach%20out%20as%20soon%20as%20you%20can.By%20eldoraui",
  },
  social: {
    github: "https://github.com/Edems-DEV",
    linkedin: "", //TODO: fix (avoid dox)
    discord: "https://discord.gg/HhfutJRXRz", //cant link to user, only server
  },
};

export const toolsText = {
  title: "Nástroje, které používám.",
  //tech - components -> incode
};

import {
  SiAngular,
  SiBootstrap,
  SiCsharp,
  SiCss3,
  SiFigma,
  SiGo,
  SiJavascript,
  SiNestjs,
  SiOpenai,
  SiPython,
  SiPytorch,
  SiReact,
  SiSocketdotio,
  SiSvelte,
  SiTailwindcss,
  SiTypescript,
  SiWindowsterminal,
} from "react-icons/si";

export enum Quality {
  Best = 0,
  Good = 1,
  Low = 2,
  Hide = 3, // more
  MoreMore = 4, // second load more (page 2)
}

export const projects: ProjectProps[] = [
  {
    id: 0,
    name: "BackCap",
    description:
      "systém pro centrální správu a kontrolu záloh, skládající se ze tří částí: SERVER, WEB a DÉMON, které spolu komunikují pomocí REST API.",
    technologies: [SiCsharp, SiAngular, SiBootstrap, SiFigma], //THINK: remove boostrap? 3max?
    techNames: ["C# MVC", "Angular", "Významně upraven", "Zobrazit návrh"],
    techLinks: [
      "https://github.com/Edems-DEV/BackCap_SERVER",
      "https://github.com/Edems-DEV/BackCap_WEB",
      "https://github.com/Edems-DEV/BackCap_WEB",
      "https://www.figma.com/file/cttIGL4CVt8KPoj63cxmig/%F0%9F%94%B4PGR---BackCap-(PUBLIC)?type=design&node-id=501-19196&t=PUmZR5UE2DPjh4H4-0",
    ],
    github: "https://github.com/Edems-DEV/BackCap",
    demo: "https://github.com/Edems-DEV/BackCap?tab=readme-ov-file#setup",
    video: "https://www.youtube.com/watch?v=pZ6YLsismIk",
    image: "/projects/BackCap/image.png",
    available: true,
    quality: Quality.Best,
  },
  {
    id: 1,
    name: "Realitky",
    description:
      "webová aplikace vytvořená v jazyce C# s architekturou MVC, obsahující dvě části: frontend pro zákazníky a backend pro administrátory a makléře.",
    technologies: [SiCsharp, SiCss3, SiSocketdotio],
    techNames: ["C# MVC", "Vanilla CSS", "SignalR - pro real-time komunikaci"],
    techLinks: [
      "https://github.com/Edems-DEV/Realitky_ASP",
      "https://github.com/Edems-DEV/Realitky_ASP",
      "https://github.com/Edems-DEV/Realitky_ASP",
    ],
    github: "https://github.com/Edems-DEV/Realitky_ASP",
    demo: "https://github.com/Edems-DEV/Realitky_ASP?tab=readme-ov-file#setup",
    image: "/projects/Realitky/image.png",
    video: "https://www.youtube.com/watch?v=COh1ZkbpsAY",
    available: true,
    quality: Quality.Best,
  },
  {
    id: 2,
    name: "Midsharp Commander",
    description:
      "replika známého linuxového nástroje Midnight Commander, vytvořená v jazyce C#.",
    technologies: [SiCsharp, SiWindowsterminal],
    techNames: ["C#", "Console App"],
    techLinks: [
      "https://github.com/Edems-DEV/midsharp-commander",
      "https://github.com/Edems-DEV/midsharp-commander",
    ],
    github: "https://github.com/Edems-DEV/midsharp-commander",
    demo: "https://github.com/Edems-DEV/midsharp-commander/releases/tag/release",
    image: "/projects/MidnightCommander/image.png",
    video: "https://www.youtube.com/watch?v=CR_YPfw8LRA",
    available: true,
    quality: Quality.Best,
  },
];

export const projects_other: ProjectProps[] = [
  {
    id: 110,
    name: "MoodleHelper",
    description:
      "AI asistent v podobě browser extension který vám pomůže se studiem v systému Moodle.",
    technologies: [SiSvelte, SiOpenai, SiGo],
    techNames: ["Svelte - browser extension", "AI api", "Go - backend"],
    techLinks: [
      "https://github.com/Edems-DEV/MoodleHelper_CLIENT",
      "https://github.com/Edems-DEV/MoodleHelper_SERVER",
      "https://github.com/Edems-DEV/MoodleHelper_SERVER",
    ],
    github: "https://github.com/Edems-DEV/MoodleHelper",
    demo: "https://chromewebstore.google.com/detail/moodlehelper/pjfgipnmbbhcegekciocaplkmhanofde",
    image: "/projects/MoodleHelper/image.png", //TODO: change
    video: "",
    available: true,
    quality: Quality.Good,
  },
  {
    id: 120,
    name: "Loop",
    description:
      "projekt vytvořený v rámci hackathonu od České spořitelny. Jedná se o front-end pro poskytnutý backend, který slouží k správě DevOps pipeline.",
    technologies: [SiReact, SiTypescript, SiTailwindcss], //TODO: TrophyIcon
    techNames: ["Vite React", "TypeScript", "Tailwind & ShadCn"],
    techLinks: [
      "https://github.com/Edems-DEV/Hackathon-CS",
      "https://github.com/Edems-DEV/Hackathon-CS",
      "https://github.com/Edems-DEV/Hackathon-CS",
    ],
    github: "https://github.com/Edems-DEV/Hackathon-CS",
    demo: "https://loop.edems.dev",
    image: "/projects/Loop/image.png", //TODO: change
    video: "https://www.youtube.com/watch?v=zYFPCS8yJ_g",
    available: true,
    quality: Quality.Good,
  },
  {
    id: 130,
    name: "Portfolio",
    description:
      "stránka na které se právě nacházíte. Vytvořena v Next.js s použitím Tailwind CSS. Určena pro prezentaci mých prací a dovedností.",
    technologies: [SiReact, SiTypescript, SiTailwindcss],
    techNames: ["React/Next.js", "TypeScript", "Tailwind CSS"],
    techLinks: [
      "https://github.com/Edems-DEV/Portfolio-V1",
      "https://github.com/Edems-DEV/Portfolio-V1",
      "https://github.com/Edems-DEV/Portfolio-V1",
    ],
    github: "https://github.com/Edems-DEV/Portfolio-V1",
    demo: "https://edems.dev",
    image: "/projects/Portfolio/image.png", //TODO: change
    video: "",
    available: true,
    quality: Quality.Low,
  },
  {
    id: 1100,
    name: "UML Editor",
    description: "program pro tvorbu UML diagramů, vytvořený v C# Winforms.",
    technologies: [SiCsharp],
    techNames: ["C# Winforms"],
    techLinks: ["https://github.com/Edems-DEV/UML-Editor"],
    github: "https://github.com/Edems-DEV/UML-Editor",
    demo: "https://github.com/Edems-DEV/UML-Editor/releases/tag/release",
    image: "/projects/UmlEditor/image.png",
    video: "https://www.youtube.com/watch?v=mIp8tLrcek8",
    available: true,
    quality: Quality.Low,
  },
  {
    id: 1110,
    name: "CS50AI",
    description:
      "Řešené projekty z kurzu umělé inteligence od Harvardské University.",
    technologies: [SiPython, SiPytorch],
    techNames: ["Python", "PyTorch"],
    techLinks: [
      "https://github.com/Edems-DEV/CS50-AI",
      "https://github.com/Edems-DEV/CS50-AI/tree/main/05_traffic",
    ],
    github: "https://github.com/Edems-DEV/CS50-AI",
    demo: "https://github.com/Edems-DEV/CS50-AI", //TODO: change
    image: "/projects/CS50AI-banner.png",
    video: "",
    available: true,
    quality: Quality.Hide,
  },
  {
    id: 1200,
    name: "ExploreCity",
    description:
      "webová aplikace obsahující dvě části: server v Nest.js a frontend v čistém JavaScriptu. Komunikují prostřednictvím RestAPI. Backend používá SQL databázi pro uchování dat.",
    technologies: [SiNestjs, SiJavascript],
    techNames: ["NestJs -> server", "Vanilla JS -> client"],
    techLinks: [
      "https://github.com/Edems-DEV/PVY_ExploreCity",
      "https://github.com/Edems-DEV/PVY_ExploreCity",
    ],
    github: "https://github.com/Edems-DEV/PVY_ExploreCity",
    demo: "https://github.com/Edems-DEV/PVY_ExploreCity", //TODO: change
    image: "/projects/ExploreCity.png",
    video: "",
    available: true,
    quality: Quality.Hide,
  },
  {
    id: 1300,
    name: "Timetracker",
    description:
      "aplikace pro sledování času stráveného na různých projektech, vytvořená v čistém JavaScriptu s použitím Bootstrapu.",
    technologies: [SiJavascript, SiBootstrap],
    techNames: ["Vanilla JS", "Boostrap"],
    techLinks: [
      "https://github.com/Edems-DEV/PVY_Timetracker",
      "https://github.com/Edems-DEV/PVY_Timetracker",
    ],
    github: "https://github.com/Edems-DEV/PVY_Timetracker",
    demo: "https://github.com/Edems-DEV/PVY_Timetracker", //TODO: change
    image: "/projects/TimeTracker/image.png",
    video: "",
    available: true,
    quality: Quality.Hide,
  },
  {
    id: 1400,
    name: "Servisní protokol",
    description:
      "program slouží k tvorbě servisního protokolu. Lze uložit jeho nastavení, a až budete hotovi, můžete nahlédnout na výsledek a následně exportovat do HTML souboru. Vše je ošetřeno validací, aby se předešlo špatným vstupům.",
    technologies: [SiCsharp],
    techNames: ["C# Winforms & GDI+"],
    techLinks: ["https://github.com/Edems-DEV/PGR_Servisni-protokol"],
    github: "https://github.com/Edems-DEV/PGR_Servisni-protokol",
    demo: "https://github.com/Edems-DEV/PGR_Servisni-protokol/releases/tag/release",
    image: "/projects/ServisniProtokol.png",
    video: "",
    available: true,
    quality: Quality.Hide,
  },
  {
    id: 1500,
    name: "ZAV-Helper",
    description:
      "pomocný nástroj vytvořen ve Winforms pro psaní testů všemi deseti, například pro ZAV.",
    technologies: [SiCsharp],
    techNames: ["C# Winforms"],
    techLinks: ["https://github.com/Edems-DEV/ZAVHelper-V3"],
    github: "https://github.com/Edems-DEV/ZAVHelper-V3",
    demo: "https://github.com/Edems-DEV/ZAVHelper-V3/releases/tag/release",
    image: "/projects/ZAV-Helper.png",
    video: "",
    available: true,
    quality: Quality.Hide,
  },
];

export const metadataText = {
  title: "Edems | Portfolio",
  description: "Moje portfolio, kde můžete najít některé z mých prací.",
  creator: "Edems",
  url: "www.edems.dev",
};
